import { Outlet, createFileRoute } from "@tanstack/react-router";
import { VideoRecorder } from "@untitled-ui/icons-react";

import TableSkeleton from "@/components/loadings/skeleton/TableSkeleton";
import type { ChildRouteContext } from "@/root";
import { redirectIfModuleDisabled } from "@/utils/permissions";

export const Route = createFileRoute("/_panel/_meet")({
  pendingComponent: TableSkeleton,
  beforeLoad: ({ context }) => {
    redirectIfModuleDisabled("meet", context.tenant.modules);

    return {
      title: () => context.t("Meeting Room", { ns: "meet.user" }),
      crumb: [
        { Icon: VideoRecorder },
        {
          label: context.t("Meeting Room", { ns: "meet.user" }),
          link: { to: "/meet/sessions" },
        },
      ],
    } satisfies ChildRouteContext;
  },
  component: Component,
});

function Component() {
  return <Outlet />;
}
